import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import Composer from "./Composer";
import { setCollection } from "../Actions/iconAction";
import { API_URL, GLYPH_COUNT } from "../constants";

// The full icon list is loaded on demand, as on the icons page
const ComposerPage = ({ icons, selectedIds, selectionReady, dispatch, location }) => {
  useEffect(() => {
    // The server preloads only the opening categories; fetch unless the full set is here
    if (icons.length >= GLYPH_COUNT) return;
    axios
      .get(API_URL + "/api/icons/all")
      .then(({ data }) => dispatch({ type: "SET_ICONS", payload: data.result }))
      .catch((error) => console.error("ico error: ", error)); // eslint-disable-line no-console
  }, []);

  return (
    <Composer
      icons={icons}
      selectedIds={selectedIds}
      selectionReady={selectionReady}
      setCollection={(list) => dispatch(setCollection(list))}
      location={location}
    />
  );
};

ComposerPage.propTypes = {
  icons: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  selectionReady: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

export default connect((store) => ({
  icons: store.localstore.icons || [],
  // The selection is changed in place, so hand over a fresh copy each time
  selectedIds: [...(store.iconstore.iconstore.selected_glyphs || [])],
  // The saved selection is read from the browser after the first render
  selectionReady: store.iconstore.fetched,
}))(ComposerPage);
